import { render } from "./ConflictPrompt.vue?vue&type=template&id=71b18896&ts=true"
import script from "./ConflictPrompt.ts?vue&type=script&lang=ts&external"
export * from "./ConflictPrompt.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__